import { render, staticRenderFns } from "./TextEditorInline.vue?vue&type=template&id=3edf5971&"
import script from "./TextEditorInline.vue?vue&type=script&lang=js&"
export * from "./TextEditorInline.vue?vue&type=script&lang=js&"
import style0 from "./TextEditorInline.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VBtnToggle,VDivider,VIcon,VMenu,VSelect,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3edf5971')) {
      api.createRecord('3edf5971', component.options)
    } else {
      api.reload('3edf5971', component.options)
    }
    module.hot.accept("./TextEditorInline.vue?vue&type=template&id=3edf5971&", function () {
      api.rerender('3edf5971', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Widget/TextEditorInline.vue"
export default component.exports